export const ALACARTE_SET_PRODUCTS = 'ALACARTE_SET_PRODUCTS';
